import { ComponentProps, FC, useMemo } from 'react';
import { Tab, TabList, TabPanel, Tabs } from '../../../../components/Tabs';
import { MovingGradient } from '../../../../components/MovingGradient';
import { DetailPageTabPlaceholder } from './DetailPageTabPlaceholder';
import { getRandomBoundary } from '../../../list/listPage/ListLoadingPlaceholder/utils';

type DetailPageTabsPlaceholderProps = ComponentProps<typeof DetailPageTabPlaceholder> & {
	tabsCount?: number;
};

const DetailPageTabsPlaceholder: FC<DetailPageTabsPlaceholderProps> = ({ tabsCount = 5, fieldsCount }) => {
	const tabs = useMemo(() => Array.from(Array(tabsCount).keys()).map((i) => i.toString()), [tabsCount]);

	return (
		<Tabs
			onTabChange={() => {}}
			activeTab={tabs[0]}
		>
			<TabList>
				{tabs.map((tab) => {
					const titleWidth = getRandomBoundary(68, 150);
					return (
						<Tab
							key={tab}
							id={tab}
							transparentActiveTab
						>
							<MovingGradient
								height='15px'
								width={titleWidth}
								style={{
									marginBottom: '1px',
								}}
							/>
						</Tab>
					);
				})}
			</TabList>
			<TabPanel id={tabs[0]}>
				<DetailPageTabPlaceholder fieldsCount={fieldsCount} />
			</TabPanel>
		</Tabs>
	);
};

export { DetailPageTabsPlaceholder };
